import { useDisclosureWithData } from '@/hooks/useDisclosureWithData';
import { FormTypeEnum } from '@/types';

import { useDeleteSupport } from '../api/delete-support';
import { TSupport } from '../types';

type TSupportsControllersReturn = {
  supportsDrawer: ReturnType<typeof useDisclosureWithData<{ type: FormTypeEnum; data: TSupport }>>;
  supportsDialog: ReturnType<typeof useDisclosureWithData<TSupport>>;
  handleDeleteSupport: () => void;
};

export function useSupportsControllers(): TSupportsControllersReturn {
  const supportsDrawer = useDisclosureWithData<{ type: FormTypeEnum; data: TSupport }>();
  const supportsDialog = useDisclosureWithData<TSupport>();
  const { mutate: deleteSupport } = useDeleteSupport();

  const handleDeleteSupport = () => {
    if (supportsDialog.data) {
      deleteSupport(
        { id: supportsDialog.data.id },
        {
          onSuccess: () => {
            supportsDialog.close();
          },
        }
      );
    }
  };

  return {
    supportsDrawer,
    supportsDialog,
    handleDeleteSupport,
  };
}
